import React from "react";
import { map, sortBy, filter } from "lodash";
import { connect } from "react-redux";
import List from "react-md/lib/Lists/List";
import ListItem from "react-md/lib/Lists/ListItem";
import Avatar from "react-md/lib/Avatars";
import { FontIcon } from "react-md";
import Button from "react-md/lib/Buttons/Button";

import { setDialog } from "../../actions/dialogActions";
import {DebugElement} from "../../Atollon/debug";
import {getHistoryUrlForInstanceUserDetail} from "../../Atollon/pages/InstanceUserDetail/shared";
import {array_utilities} from "../../Atollon/utilities/array_utilities";
import {xml_utilities} from "../../Atollon/utilities/xml_utilities";
import {TouchAvatar, TouchTable} from "../../AtollonTheme/ReactElements";

const Table = ({
                   users,
                   organization,
                   setDialog,
                   history,
                   listUsersWithoutSSO,
                   organizationUserDetails,
                   searchBar
}) => {

    /*
    users ->
        name
        role

     organization ->
        id
        name


    */

    let getUserName = ( userDetailId ) =>
    {
        // console.log('getUserName', organizationUserDetails, userDetailId );
        if( organizationUserDetails && organizationUserDetails[userDetailId] )
        {
            let userXmlAsString = organizationUserDetails[userDetailId];
            let userXml = xml_utilities.xml_from_string_dontThrowExceptions(userXmlAsString);
            let name = xml_utilities.get_first_tag_value(userXml, '//contactName', '');
            let nameAsNonNullString = name || '';
            return nameAsNonNullString;
        }
        else
        {
            return '';
        }
    };

    let listUsersWithSOO = !listUsersWithoutSSO;
    if( listUsersWithSOO )
    {

        let filteredUsers = filter( users, (item) => {

            let touchEmailIdentifier = item.name;
            // console.log('touchEmailIdentifier',touchEmailIdentifier);
            let name = getUserName( touchEmailIdentifier );

            if( searchBar.searchText )
            {
                let matches = ( string ) => {
                    return string.toLocaleLowerCase().match( searchBar.searchText.toLocaleLowerCase() );
                };
                let match = matches( name ) || matches( item.name );
                return match;
            }
            else
            {
                return true;
            }
        });
        let sortedUsers = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( filteredUsers,['name']);

          return (
                      <TouchTable
                          headerAsList={["Jméno","Role","Akce"]}
                          elementsAsList={
                            map(sortedUsers, (item, i) => {

                                    //
                                    // Avatar
                                    //
                                    //
                                    // PASTE: from InstanceUserDetail.js
                                    //

                                    let touchEmailIdentifier = item.name;
                                    // console.log('touchEmailIdentifier',touchEmailIdentifier);
                                    let name = getUserName( touchEmailIdentifier );
                                    let nameWithAvatar = (
                                        <TouchAvatar
                                          image={""}
                                          text={name}
                                          subtext={<span className={"link"}>{touchEmailIdentifier}</span>}
                                          onClick={() => history.push(`/person/${touchEmailIdentifier}`)}
                                        />
                                    );

                                  return (
                                        [
                                            nameWithAvatar,
                                            item.role,
                                            (
                                                <div>
                                                      <Button flat
                                                              primary
                                                              label="Detail uživatele"
                                                              className="btn btn-primary"
                                                              onClick={(event) => {
                                                                  event.preventDefault();

                                                                  let url = getHistoryUrlForInstanceUserDetail( organization.id, item.name );
                                                                  history.push(url);
                                                              }}
                                                      />
                                                    <FontIcon
                                                      className="icon"
                                                      onClick={() => {
                                                          setDialog("DeleteOrganizationUserBinding", {
                                                          organizationId: organization.id,
                                                          userId: item.id,
                                                          name: item.name
                                                        })}}
                                                    >
                                                      delete
                                                    </FontIcon>
                                                </div>
                                            )
                                        ]
                                  );
                            })}
                />
          );
    }
    else
    {
        let filteredUsers = filter( users, (item) => {

            let touchEmailIdentifier = item.name;

            if( searchBar.searchText )
            {
                let matches = ( string ) => {
                    return string.match( searchBar.searchText );
                };
                let match = matches( item.name );
                return match;
            }
            else
            {
                return true;
            }

        });
        let sortedUsers = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( filteredUsers,['name'] );
        return (
            <TouchTable
                headerAsList={["Jméno","","Akce"]}
                elementsAsList={
                    map( sortedUsers, (item, i) => (
                        [
                            item.name,
                            '',
                            (
                                <Button flat
                                        primary
                                        label="Detail uživatele"
                                        className="btn btn-primary"
                                        onClick={(event) => {
                                            event.preventDefault();

                                            // M: user without sso has numeric id as identifier
                                            let url = getHistoryUrlForInstanceUserDetail( organization.id, item.id );
                                            history.push(url);
                                        }}
                                />
                            )
                        ]
                    ))
                }
            />
        );
    }


};

export default connect(({searchBar}) => ({searchBar}), {
  setDialog
})(Table);



// WEBPACK FOOTER //
// ./src/components/organization/TableUsers.js